import store from 'store'
import i18n from 'i18n'
import { UTILS__VALIDATOR__is_value } from 'utils/validator'

import { MAIN_SERVER } from './instance'

export const GET_PROJECTS = async obj => {
    const params = {}

    if (UTILS__VALIDATOR__is_value(obj.status)) {
        params.status = obj.status
    }
    if (UTILS__VALIDATOR__is_value(obj.perPage)) {
        params.size = obj.perPage
    }
    if (UTILS__VALIDATOR__is_value(obj.offsetPages)) {
        params.page = obj.offsetPages
    }
    if (UTILS__VALIDATOR__is_value(obj.sort)) {
        params.sort = obj.sort
    }
    if (UTILS__VALIDATOR__is_value(obj.authorId)) {
        params.authorId = obj.authorId
    }
    if (UTILS__VALIDATOR__is_value(obj.organizationId)) {
        params.organizationId = obj.organizationId
    }

    return MAIN_SERVER({
        method: 'get',
        url: `/projects`,
        params,
    })
}

export const GET_PROJECTS_COUNT = async obj => {
    const params = {}

    if (UTILS__VALIDATOR__is_value(obj.authorId)) {
        params.authorId = obj.authorId
    }
    if (UTILS__VALIDATOR__is_value(obj.organizationId)) {
        params.organizationId = obj.organizationId
    }

    return MAIN_SERVER({
        method: 'get',
        url: `/projects/count-by-status`,
        params,
    })
}

export const GET_PROJECT = async projectId => {
    return MAIN_SERVER({
        method: 'get',
        url: `/projects/${projectId}`,
    })
}

export const CLONE_PROJECT = async projectId =>
    MAIN_SERVER({
        method: 'post',
        url: `/projects/${projectId}/clone`,
        data: {},
    })

export const DELETE_PROJECT = async projectId =>
    MAIN_SERVER({
        method: 'delete',
        url: `/projects/${projectId}`,
    })

export const UPDATE_PROJECT = async (projectId, data) =>
    MAIN_SERVER({
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 30000,
        url: `/projects/${projectId}`,
        data,
    })

export const PUBLISH = async (id, lng) => {
    const data = {}

    if (UTILS__VALIDATOR__is_value(lng)) {
        data.languageCode = lng.toUpperCase()
    } else {
        const { language } = store.getState()
        data.languageCode = language.toUpperCase()
    }

    return MAIN_SERVER({
        method: 'patch',
        url: `/projects/${id}/publish`,
        data,
    })
}

export const GET_DEFAULT_PREVIEW_IMAGE = async () =>
    MAIN_SERVER({
        method: 'get',
        headers: {
            'Content-Type': 'text/plain',
        },
        url: '/projects/preview/default-preview-image',
    })

export const SET_PROJECT_PREVIEW_IMAGE = async (projectId, imageId) =>
    MAIN_SERVER({
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/projects/${projectId}/preview-image/${imageId}`,
    })

export const SET_DEFAULT_PREVIEW_IMAGE = async projectId =>
    MAIN_SERVER({
        method: 'patch',
        url: `/projects/${projectId}/default-preview-image`,
        data: {},
    })

export const CHECK_CUSTOM_URL = async value => {
    const data = {}

    if (UTILS__VALIDATOR__is_value(value)) {
        data.customUrl = value
    }

    return MAIN_SERVER({
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 30000,
        url: '/projects/custom-url/check',
        data,
    })
}

export const SET_CUSTOM_URL = async (projectId, customUrl) => {
    return MAIN_SERVER({
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 30000,
        url: `/projects/${projectId}/custom-url/reserve`,
        data: { customUrl },
    })
}

export const SEND_CONSTRAINT = async (actionTypeName, projectId, blockId, body = {}) =>
    MAIN_SERVER({
        method: 'put',
        url: `/actions/constraints/${actionTypeName}/project-id/${projectId}/block-id/${blockId}`,
        data: {
            actionTypeName,
            projectId,
            blockId,
            ...body,
        },
    })

export const REMOVE_CONSTRAINT = async (actionTypeName, projectId, blockId) => {
    try {
        await MAIN_SERVER({
            method: 'delete',
            url: `/actions/constraints/${actionTypeName}/project-id/${projectId}/block-id/${blockId}`,
        })
    } catch (err) {
        if (err.response) {
            if (err.response.status === 404) return
        }
        throw err
    }
}

export const SET_EMAIL_INTEGRATION = async (email, projectId) =>
    MAIN_SERVER({
        method: 'patch',
        url: `/integrations/EMAIL/projects/${projectId}`,
        data: [
            {
                key: 'NOTIFICATION_EMAIL',
                value: email,
            },
        ],
    })

export const DISABLE_EMAIL_INTEGRATION = async projectId =>
    MAIN_SERVER({
        method: 'patch',
        url: `/integrations/EMAIL/projects/${projectId}/disable`,
        data: {},
    })

export const CREATE_PROJECT_FROM_TEMPLATE = async (templateId, { name, title, description } = {}) => {
    const {
        organizations: { selectedOrganizationId },
    } = store.getState()

    return MAIN_SERVER({
        method: 'post',
        url: `/projects/from-template`,
        data: {
            templateId,
            name: name || i18n.t('My project'),
            title: title || i18n.t('Interacty – engaging content'),
            description: description || i18n.t('Try it yourself!'),
            organizationId: selectedOrganizationId,
        },
    })
}

export const LINK_IMAGE_TO_PROJECT = async ({ projectId, pageId, blockId, imageId, previousImageKey }) =>
    MAIN_SERVER({
        method: 'post',
        url: `/projects/${projectId}/images/link`,
        data: {
            imageId: imageId,
            pageId: pageId,
            blockId: blockId,
            previousImageKey: previousImageKey,
        },
    })

export const UNLINK_IMAGE_FROM_PROJECT = async ({ projectId, pageId, blockId, imageKey }) =>
    MAIN_SERVER({
        method: 'post',
        url: `/projects/${projectId}/images/unlink`,
        data: {
            pageId: pageId,
            blockId: blockId,
            imageKey: imageKey,
        },
    })

export const CLEAR_LINK_IMAGES_BY = async ({ projectId, pageId, blockIds }) =>
    MAIN_SERVER({
        method: 'post',
        url: `/projects/${projectId}/images/clear-for`,
        data: {
            paths: blockIds.map(blockId => ({ pageId, blockId })),
        },
    })

export const CLONE_LINK_IMAGES_BY = async ({ projectId, existsPageId, existsBlockIds, pageId, blockIds }) => {
    if (new Set(existsBlockIds).length !== new Set(blockIds).length)
        throw Error('Invalid args. Different length of blocks')

    const data = {
        paths: existsBlockIds.map((existsBlockId, index) => {
            return {
                source: { pageId: existsPageId, blockId: existsBlockId },
                destination: { pageId: pageId, blockId: blockIds[index] },
            }
        }),
    }

    return MAIN_SERVER({
        method: 'post',
        url: `/projects/${projectId}/images/clone-for`,
        data,
    })
}

export const CHANGE_VISIBILITY = ({ projectId, isHidden }) =>
    MAIN_SERVER({
        method: 'patch',
        url: `/projects/${projectId}/hidden`,
        data: {
            hidden: isHidden,
        },
    })
